import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconMagic } from '../../assets/images/icons/icon_magic.svg';
import { getAiFeatures } from '../../views/ProductDetails/Series3CollarDetails/components/PlusNewFeatures/PlusNewFeatures';
import styles from './HardwareFirstAiBehaviors.module.scss';

/**
 * The redesign's AI behavior module: the live s3+ pdp's five behaviors as cards on a dark band. A
 * two-up grid leaves the last behavior alone on its row, so a "more coming" card fills it there.
 */
export default function HardwareFirstAiBehaviors() {
  const { t } = useTranslation();
  return (
    <section className={styles.band}>
      <h2 className={styles.title}>{t('ai_behavior_monitoring_title')}</h2>
      <p className={styles.sub}>{t('unleash_a_complete_overview_of_their_habits')}</p>
      <ul className={styles.cards}>
        {getAiFeatures(t).map(({ title, description, icon }) => (
          <li key={title} className={styles.card}>
            <span className={styles.icon} aria-hidden="true">
              {icon}
            </span>
            <span className={styles.cardTitle}>{title}</span>
            <span className={styles.cardBody}>{description}</span>
          </li>
        ))}
        <li className={styles.soon}>
          <span className={styles.soonIcon} aria-hidden="true">
            <IconMagic />
          </span>
          <span className={styles.cardTitle}>{t('pdp_v2_ai_more_title')}</span>
          <span className={styles.cardBody}>{t('pdp_v2_ai_more_body')}</span>
        </li>
      </ul>
    </section>
  );
}
